var map = {
	"./01_parking.png": 1649,
	"./02_mountains.png": 6242,
	"./03_kitchen.png": 2967,
	"./04_wifi.png": 4421,
	"./05_tv.png": 6923,
	"./06_fridge.png": 3243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5535;